import { Reveal } from "./Reveal";
import { ChevronRight } from "lucide-react";

const OFFICE_IMG =
  "https://images.unsplash.com/photo-1559136555-9303baea8ebd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3MlMjBidXNpbmVzcyUyMG9mZmljZSUyMG1vZGVybnxlbnwwfHx8fDE3ODcxNzExMjF8MA&ixlib=rb-4.1.0&q=85";

export const Growth = () => {
  return (
    <section id="growth" data-testid="growth-section" className="bg-[#0A0A0A] py-24 md:py-32 border-y border-neutral-800">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          <Reveal>
            <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6" data-testid="growth-eyebrow">
              Growth
            </p>
            <h2
              className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[1.05] text-white"
              data-testid="growth-headline"
            >
              Start With One.
              <span className="block text-orange-500">Build From There.</span>
            </h2>
            <div className="mt-8 space-y-5 text-base md:text-lg text-neutral-300" data-testid="growth-body">
              <p>
                The opportunity isn't simply owning a truck.{" "}
                <span className="text-white font-semibold">It's building a transportation company.</span>
              </p>
              <p>
                Start with the first truck. Build the operating system. Understand the economics.
                Then determine whether adding additional trucks makes sense for your business.
              </p>
              <p>
                As the company grows, the same operating infrastructure can support a larger fleet.
              </p>
            </div>
            <a
              href="#get-started"
              data-testid="growth-cta"
              className="mt-10 inline-flex items-center gap-2 bg-orange-500 px-8 py-5 font-display text-base md:text-lg font-semibold uppercase tracking-wider text-white transition-all duration-200 hover:bg-orange-600 hover:-translate-y-1"
            >
              Discuss Your Trucking Company
              <ChevronRight size={20} />
            </a>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative">
              <img
                src={OFFICE_IMG}
                alt="Modern logistics business operations"
                className="w-full h-[380px] md:h-[500px] object-cover border border-neutral-800"
                data-testid="growth-image"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/70 px-6 py-4 border-t border-orange-500">
                <p className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-orange-500">
                  Build the company — not just the truck.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
